import { RequestGroupConfigV1 } from './RequestGroupConfigV1';

export const GROUP_CONFIG_V1_META_NAME = 'GROUP_CONFIG_V1';

export type RequestGroupMetaV1 = {
  [GROUP_CONFIG_V1_META_NAME]?: RequestGroupConfigV1;
};
